import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import Swal from "sweetalert2";
import { createDoctorThunk, updateDoctorThunk } from "../../redux/slices/doctorSlice";
import { getApiErrorMessage } from "../../utils/apiError";

const EMPTY = { doctorName: "", specialization: "", mobileNumber: "", availabilitySchedule: "", status: "Active" };

const statusOptions = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

const DoctorModal = ({ show, onClose, editRecord }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm(editRecord ? { ...EMPTY, ...editRecord } : EMPTY);
  }, [editRecord, show]);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  const setSelect = (field) => (opt) => setForm((f) => ({ ...f, [field]: opt?.value ?? "" }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.doctorName.trim()) {
      Swal.fire("Required", "Doctor Name is required.", "warning"); return;
    }
    setSaving(true);
    try {
      if (editRecord?.id) {
        await dispatch(updateDoctorThunk({ id: editRecord.id, data: form })).unwrap();
      } else {
        await dispatch(createDoctorThunk(form)).unwrap();
      }
      Swal.fire({ toast: true, position: "top-end", icon: "success", title: `Doctor ${editRecord ? "updated" : "added"} successfully`, showConfirmButton: false, timer: 2000 });
      onClose();
    } catch (err) {
      Swal.fire("Error", getApiErrorMessage(err, "Failed to save doctor."), "error");
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 custom-modal-header">
              <div className="page-title">
                <h4>{editRecord ? "Edit Doctor" : "Add Doctor"}</h4>
              </div>
              <button type="button" className="close" onClick={onClose}><span>×</span></button>
            </div>
            <div className="modal-body custom-modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12 mb-3">
                    <label className="form-label">Doctor Name <span className="text-danger">*</span></label>
                    <input className="form-control" value={form.doctorName} onChange={set("doctorName")} placeholder="Dr. Full Name" />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">Specialization</label>
                    <input className="form-control" value={form.specialization} onChange={set("specialization")} placeholder="e.g. Orthodontist" />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">Mobile</label>
                    <input className="form-control" value={form.mobileNumber} onChange={set("mobileNumber")} placeholder="Mobile Number" />
                  </div>
                  <div className="col-lg-8 mb-3">
                    <label className="form-label">Availability Schedule</label>
                    <input className="form-control" value={form.availabilitySchedule} onChange={set("availabilitySchedule")} placeholder="e.g. Mon-Fri 9am-6pm" />
                  </div>
                  <div className="col-lg-4 mb-3">
                    <label className="form-label">Status</label>
                    <Select classNamePrefix="react-select" options={statusOptions}
                      value={statusOptions.find((o) => o.value === form.status) || null}
                      onChange={setSelect("status")}
                      menuPosition="fixed"
                      styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }} />
                  </div>
                </div>
                <div className="modal-footer-btn">
                  <button type="button" className="btn btn-cancel me-2" onClick={onClose}>Cancel</button>
                  <button type="submit" className="btn btn-submit" disabled={saving}>
                    {saving ? "Saving..." : editRecord ? "Save Changes" : "Add Doctor"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} />
    </>
  );
};

export default DoctorModal;
